import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import StatsBand from '../components/StatsBand';
import UseCases from '../components/UseCases';
import Features from '../components/Features';
import TechStack from '../components/TechStack';
import WhyWorkWithUs from '../components/WhyWorkWithUs';
import AboutUs from '../components/AboutUs';
import BuildPreview from '../components/BuildPreview';
import BookingSection from '../components/BookingSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="page-wrapper">
      <Header />
      <main>
        <Hero />
        <StatsBand />
        <UseCases />
        <BuildPreview />
        <Features />
        <TechStack />
        <WhyWorkWithUs />
        <AboutUs />
        <BookingSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
